export default __webpack_public_path__ + "static/media/img_13.cd48cee9.webp";